import { TransactionsModalStyled, } from "../Account/components/styled/TransactionsModalStyled.js";
import { Modal } from "react-bootstrap";
import { CashierContent } from "../Cashier/Cashier";
import { useLangContext } from "../../providers/LangProvider/LangProviderContext.js";

function TransactionsModal(props) {
    const {getLangPath} = useLangContext();
    return <TransactionsModalStyled>
        <Modal.Header closeButton>
            {getLangPath('header.cashier')}
        </Modal.Header>
        <CashierContent {...props}/>
    </TransactionsModalStyled>
}

export default TransactionsModal;
